"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import SinteredLayersDiagram from "@/components/diagrams/SinteredLayersDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
export default function MultiLayerPage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagramCopy = {
    en: {
      sectionTitle: "Engineered Multi-Layer Composite Structure",
      sectionLead: "Cross-section schematic illustrating multi-stage filtration, secondary polishing, intermediate drainage, and heavy base skeleton layers bonded by solid-state diffusion.",
      cardTitle: "Multi-Layer Composite Structural Schematic",
      cardDesc: "Protective surface (L01), primary filtration (L02), secondary polishing (L03), drainage (L04), and heavy skeleton (L05) resisting heavy delta-P spikes."
    },
    zh: {
      sectionTitle: "工程级多层复合烧结立体结构",
      sectionLead: "截面结构展示表面保护层、主过滤层、二级精滤层、中间导流层与重型底骨架在真空高温下的多层固态冶金结合形态。",
      cardTitle: "多层工程复合网截面与介质流向示意",
      cardDesc: "L01 表面保护层至 L05 重载承压底骨架层形成多阶梯度孔隙，在高抗冲与高磨损工况下保持整体结构刚度。"
    },
    es: {
      sectionTitle: "Estructura compuesta multicapa de ingeniería",
      sectionLead: "Esquema en corte transversal que ilustra filtración primaria, pulido secundario, drenaje intermedio y esqueleto pesado unidos por difusión térmica.",
      cardTitle: "Esquema compuesto multicapa",
      cardDesc: "Capas desde protección superficial (L01) hasta esqueleto de alta resistencia (L05) soportando picos severos de presión diferencial."
    },
    de: {
      sectionTitle: "Technischer Mehrlagenverbund-Querschnitt",
      sectionLead: "Querschnittsansicht mit Primärfiltration, Sekundärpolierlage, Zwischendrainage und hochbelastbarem Basisskelett im Diffusionsverbund.",
      cardTitle: "Mehrlagen-Verbundstruktur-Schema",
      cardDesc: "Schutzoberfläche (L01), Hauptfilterlage (L02), Polierschicht (L03), Drainage (L04) und Basisskelett (L05) für höchste Differenzdrücke."
    },
    fr: {
      sectionTitle: "Structure composite multicouche renforcée",
      sectionLead: "Schéma en coupe transversale illustrant la filtration primaire, la finition secondaire, le drainage intermédiaire et l'ossature lourde frittée sous vide.",
      cardTitle: "Schéma structural composite multicouche",
      cardDesc: "Surface protectrice (L01) jusqu'à l'ossature base haute résistance (L05) supportant de violents différentiels de pression."
    },
    pt: {
      sectionTitle: "Estrutura composta multicamadas de engenharia",
      sectionLead: "Esquema em corte transversal ilustrando filtração primária, polimento secundário, drenagem intermediária e esqueleto pesado unidos por difusão atômica.",
      cardTitle: "Esquema estrutural composto multicamadas",
      cardDesc: "Superfície protetora (L01) até o esqueleto de alta resistência (L05) tolerando severos picos de pressão diferencial."
    }
  };
  const d = pick(lang, diagramCopy);
  const diagram = <DiagramSection id="multi-layer-diagram" title={d.sectionTitle} lead={d.sectionLead} tone="background">
      <div className="max-w-3xl mx-auto">
        <DiagramCard index="SWM-COMPOSITE" badge="Multi-Layer Matrix" title={d.cardTitle} description={d.cardDesc}>
          <SinteredLayersDiagram variant="multi" />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}